// @ts-nocheck
/* eslint-disable */
export const copyIcon = {
  data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="3" width="10" height="12" rx="2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 13H12C13.1046 13 14 12.1046 14 11L14 3C14 1.89543 13.1046 1 12 1L6 1C4.89543 1 4 1.89543 4 3V3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'copy' as const,
};
